import React, { Component } from 'react';
import { sample } from 'lodash';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import '../desktop/css/loading.css';
import pbgLogoBlue from '../img/keytravel-logo-blue.png';
import { formatMessage } from '../lib/intl';

const i18n = defineMessages({
  gettingGroupTogether: {
    id: 'loading.copies.gettingGroupTogether',
    defaultMessage: 'getting your group together',
  },
});

class Loading extends Component {
  constructor(props) {
    super(props);
    this.formatMessage = formatMessage(this.props.intl);
  }

  randomCopy() {
    const copyId = sample(Object.keys(i18n));
    return this.formatMessage(i18n[copyId]);
  }

  render() {
    return (
      <div className="loading-page">
        <div className="text-center loading">
          <p className="loader" />
          <p>
            <img src={pbgLogoBlue} className="paybygroup-logo" alt="PayByGroup" />
          </p>
          <p>
            <FormattedMessage
              id="loading.mainText"
              defaultMessage="Loading..."
            />
            <span className="text-muted">
              {this.randomCopy()}
            </span>
          </p>
        </div>
      </div>
    );
  }
}

export default injectIntl(Loading);



// WEBPACK FOOTER //
// ./src/components/loading.js